import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import Dropdown from 'ui-library/dropdowns/Dropdown';
import AddIcon from 'ui-library/icons/AddIcon';
import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';
import Menu from 'ui-library/menus/Menu';
import {MenuHeight, MenuWidth} from 'ui-library/menus/MenuConstants';
import Option from 'ui-library/menus/Option';

interface AddBinDropdownProps {
  onAddNewFragmentBin: () => void;
  onAddNewSpacerBin: () => void;
  spacerName?: string;
  fragmentIcon: BenchlingIconName;
}

export function AddBinDropdown({
  onAddNewFragmentBin,
  onAddNewSpacerBin,
  spacerName,
  fragmentIcon,
}: AddBinDropdownProps): JSX.Element {
  return (
    <Dropdown
      menu={
        <Menu height={MenuHeight.MEDIUM} width={MenuWidth.MEDIUM}>
          <Option
            icon={fragmentIcon}
            onSelect={onAddNewFragmentBin}
            dataTestAttrs={{component: 'BulkAssemblyAddBinDropdown', element: 'dropdown', key: 'fragmentBin'}}
          >
            Add new bin
          </Option>
          {spacerName != null && (
            <Option
              icon="spacer"
              onSelect={onAddNewSpacerBin}
              dataTestAttrs={{component: 'BulkAssemblyAddBinDropdown', element: 'dropdown', key: 'spacer'}}
            >
              Add new {spacerName}
            </Option>
          )}
        </Menu>
      }
      closeOnInsideClick={true}
      closeOnOutsideClick={true}
    >
      <AddIcon
        altText={
          spacerName != null
            ? `Add a new bin or ${spacerName} to the assembly`
            : 'Add a new bin to the assembly'
        }
        className={css(styles.addCardButton)}
        dataTestAttrs={{component: 'BulkAssemblyAddBinDropdown', element: 'button'}}
      />
    </Dropdown>
  );
}

const styles = StyleSheet.create({
  addCardButton: {
    marginLeft: '8px',
    height: '16px',
    width: '16px',
  },
});
